import { useState } from "react";
import { LupaDeAmpliar } from "../../components/Ampliar.js";
import { VisorDeImagem } from "../../components/VisorDeImagem.js";
import { AREA_UTIL_DA_FOLHA, TAMANHO_DA_FOLHA } from "../../components/visor.js";
import { cx } from "../../components/ui.js";
import type { SaidaRota } from "../../lib/trpc.js";
import { estiloDaGrade } from "../impressao/ampliar-fotos.js";

type Conjunto = SaidaRota["marcadores"]["list"][number];

/** Data curta, sem hora, como nas listas do resto do sistema. */
const data = (d: Date | string) =>
  new Date(d).toLocaleDateString("pt-BR", { day: "2-digit", month: "short" });

/**
 * A lista "Já feitos": uma folha por conjunto. Tocar abre o conjunto, como sempre; a lupa abre a folha
 * em resolução cheia no visor, para conferir um acento ou o picotado sem abrir o conjunto.
 */
export function ConjuntosFeitos({
  feitos,
  aberto,
  aoAbrir,
}: {
  feitos: readonly Conjunto[];
  aberto: number | null;
  aoAbrir: (id: number) => void;
}) {
  const [ampliando, setAmpliando] = useState<number | null>(null);
  const emVisor = ampliando !== null ? feitos.find((m) => m.id === ampliando) : undefined;

  return (
    <>
      <ul className="grid gap-3" style={estiloDaGrade("8rem")}>
        {feitos.map((m) => (
          <li key={m.id} className="relative">
            <button
              type="button"
              onClick={() => aoAbrir(m.id)}
              aria-pressed={aberto === m.id}
              className={cx(
                "flex w-full flex-col gap-1.5 rounded-peca border-2 p-1.5 text-left",
                aberto === m.id ? "border-brasa" : "border-transparent hover:border-borda-forte",
              )}
            >
              <img
                src={m.folha.mini}
                alt=""
                loading="lazy"
                className="aspect-[1181/1748] w-full rounded-peca bg-white object-cover"
              />
              <span className="truncate text-[0.8125rem] text-texto">{m.titulo}</span>
              <span className="truncate text-[0.75rem] text-texto-suave">
                {m.nome} · {data(m.criadoEm)}
              </span>
            </button>
            <LupaDeAmpliar
              rotulo={`Ampliar a folha de ${m.titulo}`}
              aoClicar={() => setAmpliando(m.id)}
              className="absolute top-0.5 right-0.5"
            />
          </li>
        ))}
      </ul>

      {emVisor && (
        <VisorDeImagem
          titulo={`Folha de marcadores · ${emVisor.titulo}`}
          fotoUrl={`/api/marcadores/${emVisor.id}/folha`}
          previa={emVisor.folha.tela}
          tamanho={TAMANHO_DA_FOLHA}
          alt={`Folha com os três marcadores de ${emVisor.titulo}`}
          areaUtil={AREA_UTIL_DA_FOLHA}
          aoFechar={() => setAmpliando(null)}
        />
      )}
    </>
  );
}
